module.exports = __webpack_public_path__ + "static/3-3@2x-2b7f06559d52c3a2ea2a1b2f1a9c33ab.png";